module.exports = __webpack_public_path__ + "static/who_we_work_with-18ffa3d7f86156e2f2c554a1fccd45c2.png";